import { Vue, Component, Prop } from 'vue-property-decorator';
import ShopDisplayConfig from '@/views/components/displayConfig/displayConfig.vue'; // 展示配置
import ShareConfig from '@/views/components/newDisplayConfig/shareConfig';
import style from '@/views/components/newDisplayConfig/style.vue';

@Component({
  components: { ShopDisplayConfig, ShareConfig },
  mixins: [style],
})
export default class DisplayConfig extends Vue {
  tabsSelect = 'shop';

  render(h) {
    return (
      <el-container class="new-display-config">
        <el-aside width="100%">
          <el-tabs tab-position="left" class="el-tabs" v-model={this.tabsSelect}>
            <el-tab-pane label="商城页配置" name="shop">
              {this.tabsSelect === 'shop' && <ShopDisplayConfig refs="ShopDisplayConfig" />}
            </el-tab-pane>
            <el-tab-pane label="分享配置" name="shareConfig">
              {this.tabsSelect === 'shareConfig' && <ShareConfig refs="shareConfig" fromPage={4} postParams={{
                siteId: Number.parseInt(this.$route.params.siteId),
                sgId: Number.parseInt(this.$route.params.sgId),
              }}
              />}
            </el-tab-pane>
          </el-tabs>
        </el-aside>
      </el-container>
    );
  }
}
